import React, { useContext } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import BugReportIcon from "@mui/icons-material/BugReport";
import versionData from "../version.json";
import { isPharlap } from "../utils/constants/constants";
import { useTranslation } from "react-i18next";
import { UserContext } from "../context/UserContext";

interface AboutDialogProps {
  open: boolean;
  onClose: () => void;
}

const AboutDialog: React.FC<AboutDialogProps> = ({ open, onClose }) => {
  var sysType: String = "SentioWeb Standard";
  const { t } = useTranslation();
  const userCtx = useContext(UserContext);

  //console.log ("Build number:", process.env.REACT_APP_BUILD_NUMBER, process.env.REACT_APP_BUILD_DATE)
  if (isPharlap) {
    sysType = "Pharlap";
  }

  const handleReportBug = () => {
    const subject = `Bug report - ${sysType} ${versionData.softwareVersion}`;
    const body = [
      `${t("system_type")}: ${sysType}`,
      `${t("software_variant")}: ${userCtx?.user?.sentio_variant}`,
      `${t("system_version")}: ${versionData.softwareVersion}`,
      `${t("build_date")}: ${process.env.REACT_APP_BUILD_DATE}`,
      `${t("build_number")}: ${process.env.REACT_APP_BUILD_NUMBER}`,
      `Git hash: ${process.env.REACT_APP_GIT_COMMIT}`,
      `User: ${userCtx?.user?.first_name} ${userCtx?.user?.last_name}`,
      `URL: ${window.location.href}`,
      `User agent: ${navigator.userAgent}`,
      "",
      "Please describe the issue below:",
      "",
    ].join("\n");
    const bugReportEmail =
      process.env.REACT_APP_BUG_REPORT_EMAIL || "support@infiniwell.ai";
    const mailtoUrl = `mailto:${bugReportEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    // Anchor-click is more reliable than location.href for triggering the OS mail client
    const link = document.createElement("a");
    link.href = mailtoUrl;
    link.click();
  };

  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="about-dialog-title">
      <DialogTitle id="about-dialog-title">{t("about_system")}</DialogTitle>
      <DialogContent>
        <Typography>
          {t("system_type")} : {sysType}
        </Typography>
        <Typography>
          {t("software_variant")} : {userCtx?.user?.sentio_variant}
        </Typography>
        <Typography>
          {t("system_version")} : {versionData.softwareVersion}
        </Typography>
        <Typography>
          {t("build_date")} : {process.env.REACT_APP_BUILD_DATE}
        </Typography>
        <Typography>
          {t("build_number")} : {process.env.REACT_APP_BUILD_NUMBER}
        </Typography>
        <Typography>Git hash: {process.env.REACT_APP_GIT_COMMIT}</Typography>
      </DialogContent>
      <DialogActions>
        <Button startIcon={<BugReportIcon />} onClick={handleReportBug}>
          {t("report_bug")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AboutDialog;
